/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section2_Li4Inputs */

const en_privacy_section2_li4 = /** @type {(inputs: Privacy_Section2_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies for tracking purposes (only localStorage for theme/locale preferences)`)
};

const ko_privacy_section2_li4 = /** @type {(inputs: Privacy_Section2_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추적 목적의 쿠키 (테마/언어 설정을 위한 localStorage만 사용)`)
};

const ja_privacy_section2_li4 = /** @type {(inputs: Privacy_Section2_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トラッキング目的のCookie（テーマ/言語設定用のlocalStorageのみ使用）`)
};

/**
* | output |
* | --- |
* | "Cookies for tracking purposes (only localStorage for theme/locale preferences)" |
*
* @param {Privacy_Section2_Li4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_section2_li4 = /** @type {((inputs?: Privacy_Section2_Li4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section2_Li4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_section2_li4(inputs)
	if (locale === "ko") return ko_privacy_section2_li4(inputs)
	return ja_privacy_section2_li4(inputs)
});